<div class="linkedin-shell" *ngIf="!loading(); else loadingState">
  <header class="linkedin-header">
    <div>
      <h1>{{ record()?.company_name || 'LinkedIn Profiles' }}</h1>
      <p *ngIf="record()?.website" class="linkedin-header__meta">
        {{ record()?.website }}
      </p>
    </div>
    <div class="linkedin-header__actions">
      <button
        type="button"
        class="button button--secondary"
        (click)="goBackToContact()"
      >
        Back to Company Contact
      </button>
    </div>
  </header>

  <section class="status status--error" *ngIf="errorMessage()">
    {{ errorMessage() }}
  </section>

  <section class="linkedin-summary" *ngIf="record()">
    <div class="status status--info" *ngIf="linkedinLoading()">
      <span class="spinner__dot"></span>
      <span>Fetching LinkedIn profile information...</span>
    </div>

    <div *ngIf="linkedinError() && !linkedinLoading()" class="status status--error">
      {{ linkedinError() }}
    </div>

    <ng-container *ngIf="linkedinDetails()">
      <ng-container *ngIf="profileRows().length; else noProfiles">
        <div class="linkedin-table-filter">
          <input
            type="search"
            class="linkedin-table-filter__input"
            [value]="tableFilterQuery()"
            (input)="onTableFilterInput($event)"
            placeholder="Filter results"
            aria-label="Filter LinkedIn profiles"
          />
        </div>
        <ng-container
          *ngIf="filteredProfileRows().length; else noFilteredResults"
        >
          <div class="linkedin-table-wrapper">
            <table class="linkedin-table" aria-label="LinkedIn profiles">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Position</th>
                  <th scope="col">Experience</th>
                  <th scope="col">Profile Link</th>
                  <th scope="col">Contact Information</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of filteredProfileRows()">
                  <td data-label="Name">{{ row.name }}</td>
                  <td data-label="Position">{{ row.position }}</td>
                  <td data-label="Experience">{{ row.experience }}</td>
                  <td data-label="Profile Link">
                    <ng-container *ngIf="row.profileUrl !== 'N/A'; else noProfileLink">
                      <a
                        [href]="row.profileUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="linkedin-table__link"
                      >
                        {{ row.profileUrl }}
                      </a>
                    </ng-container>
                  </td>
                  <td data-label="Contact Information">{{ row.contactInfo }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </section>
</div>

<ng-template #noProfiles>
  <p class="linkedin-summary__empty">
    {{ linkedinDetails()?.message || 'No LinkedIn profiles were found for this search.' }}
  </p>
</ng-template>

<ng-template #refreshPending>
  <span class="spinner">
    <span class="spinner__dot"></span>
    <span>Refreshing...</span>
  </span>
</ng-template>

<ng-template #noFilteredResults>
  <p class="linkedin-summary__empty">
    No results match the current filter.
  </p>
</ng-template>

<ng-template #noProfileLink>
  <span class="linkedin-table__link--empty">N/A</span>
</ng-template>

<ng-template #loadingState>
  <div class="linkedin-loading">
    <span class="spinner">
      <span class="spinner__dot"></span>
      <span>Loading contact details...</span>
    </span>
  </div>
</ng-template>
